import type { Drug } from "../../types";

export const mysimbaDrug: Drug = {
  id: "mysimba",
  name: "Naltrexone/bupropion (Mysimba®)",
  drugClass: "Naltrexone/bupropion combination",
  route: "oral",
  defaultFoodTiming: "Take with food",
  swallowingNote: "Tablets must be swallowed whole — do not cut, chew, or crush.",
  formulations: [
    {
      id: "mysimba-8mg-90mg-tablet",
      type: "tablet_mr",
      storageNote:
        "Store below 30°C in original packaging. Shelf life 30 months. Keep out of reach of children.",
      prescribedItemId: "1451dcea-ba3e-400b-a3ee-ad11f1210f2c",
    },
  ],
};
